<template>
  <v-container fluid>
    <v-row>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Customer Invoice</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          small
          text
          :to="`/freight/containers/manifest/${invoiceItem.container_id}`"
        >
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <!-- invoice editor -->
      <editor
        :invoiceItem="invoiceItem"
        :manifestData="manifestData"
        :invoiceArray="invoiceArray"
        :payments="payments"
      ></editor>
      <!-- end of invoice editor -->
    </v-row>
  </v-container>
</template>

<script>
import Editor from "../_components/invoice-editor.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Editor,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  data: () => ({
    dataItem: {},
    dialog: false,
    accountId: null,
    PaymentRemarks: null,
    payments: [],
    amount: null,
    accounts: [],
    invoiceArray: [],
    loader: false,
    activeItem: {},
    Description: null,
    search: null,
    invoiceDialog: false,
    invoiceItem: {},
    manifestData: {},
    date: new Date().toISOString().substr(0, 10),
    docCreate: false,
    headers: [
      { text: "Qty", value: "Quantity" },
      { text: "Description", value: "Description" },
      // { text: "Price", value: "Price" },
      // { text: "Total", value: "LineTotal" },
    ],
    paymentHeaders: [
      { text: "Account", value: "oact.Name" },
      { text: "Amount", value: "SumApplied" },
      { text: "Ref No / Remarks", value: "PaymentRemarks" },
      // { text: "Date", value: "created_at" },
      { text: "Received By", value: "receivedby.name" },
    ],
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      let manifestId = val;
      const self = this;
      this.$store
        .dispatch("get", `/manifest/invoice/${manifestId}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.invoiceItem = res.ResponseData.invoice;
            self.manifestData = res.ResponseData.manifest;
            self.invoiceArray = res.ResponseData.invoice.rows;
            self.payments = res.ResponseData.payments;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    savePayment() {
      if (
        (this.date == null || this.date == undefined) &&
        this.dateReadonly == "N"
      ) {
        this.$refs.snackbar.show("Please select date!", "red");
      } else {
        const self = this;

        const data = {
          CardCode: self.invoiceItem.ocrd.id,
          DocDate: self.date,
          o_a_c_t_s_id: self.accountId,
          SumApplied: self.amount,
          PaymentRemarks: self.PaymentRemarks,
        };
        if (this.accountId == null || this.amount == null) {
          this.$refs.snackbar.show("Account or amount missing!", "red");
        } else {
          const url = "/incoming-payments";
          this.loader = true;
          this.$store
            .dispatch("post", { url, data })
            .then((res) => {
              if (res.ResultCode == 1200) {
                self.loader = false;
                location.reload();
              } else {
                self.loader = false;
                this.$refs.snackbar.show(res.ResultDesc, "red");
              }
            })
            .catch((err) => {
              self.loader = false;
              this.$refs.snackbar.show(err, "red");
            });
        }
      }
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>